import React from "react";

const ResultsLoading = () => {
  // TODO: Add loading screen
  return (
    <div className="ft_dealer-locator__loading">
      Loading
    </div>
  );

}

export default ResultsLoading;
